/* eslint-disable */
// src/tables/visitStrategies/CashStrategy.js

import React from "react";
import BaseStrategy from "./BaseStrategy";
import {
  ROCKOLA_DATA_WIDTH,
  centeredDataBlockStyle,
  compactNumericInputStyle,
} from "components/visit/individualEditorSizing";

export default class CashStrategy extends BaseStrategy {
  buildCells(m) {
    const key = this.computeKey(m);
    const isCollected = this.isWasCollected(m, key);
    const moneyCollected = this.pickNumber(m, "moneyCollected", "MoneyCollected");
    const moneyIn = this.pickNumber(m, "moneyIn", "MoneyIn");

    // Rockola: NO fórmula
    const machineCell = this.MachineCell({ m, hasRent: false, formulaText: null });
    const noteCell = this.NoteCell({ keyId: key, m });

    if (!isCollected && this.isRead) {
      return { Machine: machineCell, Note: noteCell };
    }

    let inCell = null;
    if (this.isRead) {
      inCell = (
        <div>
          Ingreso:{" "}
          <strong>
            {this.moneyFmt.format(moneyCollected ?? moneyIn ?? 0)}
          </strong>
        </div>
      );
    } else {
      inCell = (
        <div style={this.individualEditorLayout ? centeredDataBlockStyle(ROCKOLA_DATA_WIDTH) : undefined}>
          {this.NumericInput({
            id: `moneyIn-${key}`,
            name: `moneyIn-${key}`,
            label: "Ingreso:",
            keyId: key,
            field: "MoneyIn",
            inputStyleOverride: {
              fontWeight: 700,
              ...(this.individualEditorLayout ? compactNumericInputStyle : {}),
            },
          })}
        </div>
      );
    }

    return { Machine: machineCell, In: inCell, Note: noteCell };
  }
}

